module.exports = __webpack_public_path__ + "img/mail_detail_empty.9c385e85.png";